import { render, staticRenderFns } from "./StepBookingCovidDisclaimer.vue?vue&type=template&id=217ec53c&"
import script from "./StepBookingCovidDisclaimer.vue?vue&type=script&lang=js&"
export * from "./StepBookingCovidDisclaimer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports